<!--===============================
=            DRAGGABLE            =
================================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Draggable</div>
      </base-header>
    </v-row>
    <v-row>
      <template>
       
        <v-col cols="12" md="3" sm="12"    v-for="column in columns"
					   :key="column.title">
          <base-card>
            <div slot="card-header">
		{{column.title}}
             	
            </div>  <div slot="card-subheader">Duis dolore ad tempor ex incididunt. </div>
            <div slot="card-body">
             
				
						<div class="pa-3 ">
							<draggable class="transparent" :list="column.tasks"
									   :animation="200"
									   ghost-class="ghost-card"
									   group="tasks">
								<!-- Each element from here will be draggable and animated. Note :key is very important here to be unique both for draggable and animations to be smooth & consistent. -->
								<task-card v-for="(task) in column.tasks" :class="$vuetify.theme.dark ? 'card-dark' : 'card-light'"
										   :key="task.id"
										   :task="task"
										   class="mt-3 cursor-move"></task-card>
								<!-- </transition-group> -->
							</draggable> </div>
						
            </div>
          </base-card>
        </v-col>
      
      </template>
    </v-row>
  <v-row>
  <div style="height:150px"></div>
  </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'

	import draggable from "vuedraggable";
	import TaskCard from "../../components/Apps/draggable/TaskCard.vue"
	export default {
		components: {
			BaseCard,
			BaseHeader,
			TaskCard,
			draggable
		},
		data() {
			return {
				columns: [{
						title: "Backlog",
						tasks: [{
								id: 1,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							},
							{
								id: 2,
								title: "Provide documentation on integrations",
								date: "Sep 12"
							},
							{
								id: 3,
								title: "Design shopping cart dropdown",
								date: "Sep 9",
								type: "Design"
							},
							{
								id: 4,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							},
							{
								id: 5,
								title: "Test checkout flow",
								date: "Sep 15",
								type: "QA"
							}
						]
					},
					{
						title: "In Progress",
						tasks: [{
								id: 6,
								title: "Design shopping cart dropdown",
								date: "Sep 9",
								type: "Design"
							},
							{
								id: 7,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							},
							{
								id: 8,
								title: "Provide documentation on integrations",
								date: "Sep 12",
								type: "Backend"
							}
						]
					},
					{
						title: "Review",
						tasks: [{
								id: 9,
								title: "Provide documentation on integrations",
								date: "Sep 12"
							},
							{
								id: 10,
								title: "Design shopping cart dropdown",
								date: "Sep 9",
								type: "Design"
							},
							{
								id: 11,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							},
							
						]
					},
					{
						title: "Done",
						tasks: [{
								id: 14,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							},
							{
								id: 15,
								title: "Design shopping cart dropdown",
								date: "Sep 9",
								type: "Design"
							},
							{
								id: 16,
								title: "Add discount code to checkout page",
								date: "Sep 14",
								type: "Feature Request"
							}
						]
					}
				]
			};
		}
    
  }
</script>


<!--====  End of DRAGGABLE  ====-->
